function noop(...a) {
}

export const throttle = (fn = noop, interval: number) => {
  let last = 0;
  return function (...a) {
    const curr = +new Date();
    if (curr - last > interval) {
      fn.apply(this, arguments);
      last = curr;
    }
  };
};
